<template>
    <div class="row">
        <!-- main title -->
        <div class="col-12">
            <div class="main__title">
                <h2> زیرنویس های قسمت: {{name}}</h2>
            </div>
        </div>
        <!-- end main title -->

        <!-- form -->
        <div class="col-12">
            <div class="form">
                <div class="row">


                    <div class="col-12 col-md-7 form__content">
                        <div class="col-12 col-md-5 form__cover">
                            <div class="row">
                                <div class="col-6 col-sm-6 col-md-12">
                                    <div class="form__group">
                                        <ImageSelector label="زیرنویس "
                                                       v-model:previewImage="file_preview"
                                                       @imagefile="(n) => file = n"
                                        />

                                    </div>
                                </div>
                                <div class="col-6 col-lg-6">
                                    <div class="form__group">
                                        <treeselect v-model="selected_language"
                                                    :multiple="false"
                                                    :normalizer="normalizer_language"
                                                    :options="languages"/>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>


                    <div class="col-12">
                        <div class="row">

                            <div class="col-12">
                                <button type="button" class="form__btn" @click="insert_data">{{status_form ==0 ?
                                    'افزودن' : 'ویرایش'}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">

            <div class="row">
                <!-- main title -->
                <!-- end main title -->

                <!-- users -->
                <div class="col-12">
                    <Datatable
                            :items="items"
                            :fields="fields"
                            style="overflow: auto"
                            :items-per-page="20"
                            hover
                            height="300px"
                            border
                            striped
                            sorter
                            column-filter
                            pagination
                    >
                        <template #row="{item,index}">
                            <td>
                                <div class="main__table-text">{{index+1}}</div>
                            </td>
                        </template>
                        <template #language="{item}">
                            <td>
                                <div class="main__table-text" >{{languages.filter(x=>x.id==item.language_id)[0].name}}</div>
                            </td>
                        </template>
                        <template #operation="{item}">
                            <td>
                                <div class="main__table-btns">

                                    <div @click="delete_data(item)" datas="#modal-delete"
                                         class="main__table-btn main__table-btn--delete open-modal">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                            <path d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z"/>
                                        </svg>
                                    </div>
                                </div>
                            </td>
                        </template>
                    </Datatable>

                </div>


            </div>
        </div>
        <!-- end form -->
    </div>
</template>

<script>
    import axios from "axios";
    // import {bus} from '../main';
    import Datatable from "@/views/customTable/Datatable";
    import ImageSelector from "@/views/CustomComponent/ImageSelector";

    import Treeselect from 'vue3-treeselect'
    import 'vue3-treeselect/dist/vue3-treeselect.css'

    export default {
        name: 'HelloWorld',
        data() {
            return {
                languages: [],
                items: [],
                fields: [
                    {key: 'row', label: 'ردیف'},
                    {key: 'language', label: 'زبان'},
                    {key: 'file', label: 'فایل'},
                    {key: 'operation', label: 'عملیات'}
                ],
                status_form: 0,
                selected_language: null,
                name: '',
                file: null,
                file_preview: null,
                normalizer_language(node) {
                    return {
                        id: node.id,
                        label: node.name,
                    }
                },
            }
        },
        components: {
            Datatable,
            ImageSelector,
            Treeselect
        },
        mounted() {
            this.get_languages();
        },
        methods: {
            edit_item(item) {
                this.link = item.link;
                this.status_form = item.id;
            },
            get_data() {

                var self = this;

                var formData = new FormData();
                formData.append('episode_id', this.$route.params.episode_id);

                this.axios.post('get_episode_with_subtitle', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    self.items = content_data.subtitles

                    self.name = content_data.name
                }).catch(function (error) {
                    console.log(error);
                });


            },
            get_languages() {

                var self = this;

                var formData = new FormData();

                this.axios.post('get_languages', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    self.languages = content_data
                    self.get_data();

                }).catch(function (error) {
                    console.log(error);
                });


            },

            insert_data() {

                var self = this;
                if (this.name == "") {
                    return
                }
                var formData = new FormData();
                var url = 'insert_episode_subtitle'
                formData.append('subtitle', this.file);
                formData.append('episode_id', this.$route.params.episode_id);
                formData.append('language_id', this.selected_language);
                if (this.status_form != 0) {
                    formData.append('id', this.status_form);
                    url = 'update_episode_subtitle'
                }
                this.axios.post(url, formData, {}).then(function (response) {

                    self.get_data()
                    self.file =null
                    self.status_form = 0;
                    self.$toast.success('ثبت با موفقیت انجام شد');

                }).catch(function (error) {
                    console.log(error);
                    self.$toast.error('خطا در ثبت اطلاعات');

                });


            },
            delete_data(item) {

                var self = this;
                if (this.name == "") {
                    return
                }
                var formData = new FormData();
                var url = 'delete_episode_subtitle'
                formData.append('episode_id', this.$route.params.episode_id);
                formData.append('id', item.id);

                this.axios.post(url, formData, {}).then(function (response) {

                    self.get_data()
                    self.file =null
                    self.status_form = 0;

                }).catch(function (error) {
                    console.log(error);
                });


            },
        }
    }
</script>

